import React, { Suspense, useEffect,  } from "react";
import { BrowserRouter as Router, Routes, Route,  } from 'react-router-dom';

import { 
  HomeScreen,
  ShopListScreen,
  LoginByScan,
  AutoLoginScreen,
  MasterScreen,
  DashboardScreen,
  ReportByItem,
  ReportByConsignment,
  ReportByCategory,
  ReportByPayment,
  ReportBillScreen,
  ReportShiftScreen,
  ReportDailyScreen,
  PriceTagScreen,
  InboundHistoryScreen,
  InboundItemScreen,
  InboundVenderScreen,
  UploadProductScreen,
  ReportVatScreen,
  ReportCheckInScreen,
  TrendSaleScreen,
  TrendCategoryScreen,
  TrendProductScreen,
  TrendPaymentScreen,
  TrendDiscountScreen,
  CompareCategoryScreen,
  MemberScreen,
  UploadMemberScreen,
  ManualUploadScreen,
  PackageScreen,
  RequisitionScreen,
  SelfServiceScreen,
  FranchiseListScreen
} from './screens';
import 'rsuite/dist/rsuite.min.css';
import PriceCardScreen from "./screens/PriceCardScreen";
import { firebaseAuth } from './db/firestore';
import { useDispatch, useSelector } from "react-redux";
import { login } from "./redux/authSlice";

function App() {
    const dispatch = useDispatch();

    const { currentUser } = useSelector( state => state.auth);
    const { language } = useSelector( state => state.device);
    const { profile:{ portOwner = [] } } = useSelector(state=>state.profile);

  
    useEffect(() => {
      let unsubscribe;
      async function checkAuth (){
        unsubscribe = await firebaseAuth.onAuthStateChanged(user => {
          if(!!user?.uid){ // ไม่มี 
            dispatch(login(user));
          } else {
            let obj =  firebaseAuth.signInWithEmailAndPassword('anonymoususer@gmail.com', '123123')
            // let obj =  firebaseAuth.signInWithEmailAndPassword('siripongsrisukha@gmail.com', '123456')
            dispatch(login(obj));
          }
        })
      }

      if (!currentUser?.user) {
        checkAuth()
      }
    },[]);

  return (
    <Router>
      <div>
          <Routes>
              <Route path='/' element={<HomeScreen/>} />
              <Route path='shoplist' element={<ShopListScreen/>} />
              <Route path='scan' element={<LoginByScan/>} />
              <Route path='auto/:docId' element={<AutoLoginScreen/>} />
              <Route path='franchise/:docId' element={<FranchiseListScreen/>} />
              <Route path='master' element={<MasterScreen/>} >
                  <Route index  element={<DashboardScreen/>} />
                  <Route path='dashboard' element={<DashboardScreen/>} />
                  <Route path='item' element={<ReportByItem/>} />
                  <Route path='consigment' element={<ReportByConsignment/>} />
                  <Route path='reportCategory' element={<ReportByCategory/>} />
                  <Route path='reportPayment' element={<ReportByPayment/>} />
                  <Route path='reportBill' element={<ReportBillScreen/>} />
                  <Route path='reportShift' element={<ReportShiftScreen/>} />
                  <Route path='reportDaily' element={<ReportDailyScreen/>} />
                  <Route path='priceTag' element={<PriceTagScreen/>} />
                  <Route path='inbound' element={<InboundHistoryScreen/>} />
                  <Route path='inboundItem' element={<InboundItemScreen/>} />
                  <Route path='inboundVender' element={<InboundVenderScreen/>} />
                  <Route path='reportVat' element={<ReportVatScreen/>} />
                  <Route path='reportCheckIn' element={<ReportCheckInScreen/>} />
                  <Route path='trendSale' element={<TrendSaleScreen/>} />
                  <Route path='trendCategory' element={<TrendCategoryScreen/>} />
                  <Route path='trendPayment' element={<TrendPaymentScreen/>} />
                  <Route path='trendProduct' element={<TrendProductScreen/>} />
                  <Route path='trendDiscount' element={<TrendDiscountScreen/>} />
                  <Route path='compareCategory' element={<CompareCategoryScreen/>} />
                  <Route path='member' element={<MemberScreen/>} />
                  <Route path='uploadMember' element={<UploadMemberScreen/>} />
                  <Route path='package' element={<PackageScreen/>} />
                  <Route path='requisition' element={<RequisitionScreen/>} />
              </Route>
              <Route path='tag/:docId' element={<PriceCardScreen/>} />
              <Route path='upload/:docId' element={<UploadProductScreen/>} />
              <Route path='manual' element={<ManualUploadScreen/>} /> 
              <Route path='selfService' element={<SelfServiceScreen/>} />



          </Routes>
      </div>
    </Router>
  );
}

export default function WrappedApp() {
  return (
    <Suspense fallback="...loading">
      <App />
    </Suspense>
  )
}

